import React from "react";
import { ReportDetails } from "@sscs/types";
import { LongTextLabel, TextWithStatus } from "@sscs/ui";
import { LinkToReport, RemovalStatus } from "Components";
import styles from "./fileRow.module.scss";

type FileNameProps = {
  rowIndex: number;
  reportDetails: ReportDetails;
  fileName: string;
  daysUntilDeletion: number | undefined;
  hasReport: boolean;
};

const FileName = ({
  rowIndex,
  reportDetails,
  fileName,
  daysUntilDeletion,
  hasReport,
}: FileNameProps): React.JSX.Element => {
  return (
    <div className={styles["file-name"]}>
      <TextWithStatus
        text={
          hasReport ? (
            <LinkToReport id={`file-${rowIndex}`} report={reportDetails}>
              <LongTextLabel label={fileName} />
            </LinkToReport>
          ) : (
            <LongTextLabel label={fileName} />
          )
        }
      >
        <RemovalStatus daysUntilDeletion={daysUntilDeletion} />
      </TextWithStatus>
    </div>
  );
};

export default FileName;
